import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ReviewDetails } from '../models/ReviewDetails';
import { BehaviorSubject } from 'rxjs';
import { UserInfo } from '../models/UserInfo';
import { AllMasterData } from '../models/AllMasterData';
import { EstimateUser } from '../models/EstimateUser';
import { EstimateUserPreferences } from '../models/EstimateUserPreferences';
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {
    private userInfo: UserInfo = new UserInfo();
  private emailSymbolCheckedSource = new BehaviorSubject<boolean>(false);
  emailSymbolChecked$ = this.emailSymbolCheckedSource.asObservable();
  private userInfoSource = new BehaviorSubject<UserInfo>(this.userInfo);
  LoggedInUser = this.userInfoSource.asObservable();
  triggerTabMethod$ = new Subject<void>();
  reviewList: ReviewDetails[] = new Array<ReviewDetails>();
  allMasterDataValues = new BehaviorSubject<AllMasterData|null>(null);
  emailIdToOpenUser: string = '';
  isUserDetailsFormModified = false;
  selectedLocale: string = '';

  // ─── Library read-only state ─────────────────────────────────────────────
  //  A single flag. The app-side ReviewDetailComponent is the sole writer —
  //  it computes `appFlag OR statusIsRead` and pushes the combined value via
  //  `setLibraryReadOnlyMode`. The library never writes back to the app.
  private readonly _libraryReadOnlyMode$ = new BehaviorSubject<boolean>(false);
  readonly libraryReadOnlyMode$: Observable<boolean> = this._libraryReadOnlyMode$.asObservable();

  /** Snapshot getter for the library read-only state. */
  get libraryReadOnlyMode(): boolean {
    return this._libraryReadOnlyMode$.value;
  }

  /** Push a new value into the library read-only flag. */
  setLibraryReadOnlyMode(value: boolean): void {
    this._libraryReadOnlyMode$.next(value);
  }

  private _decimalPrecision: number = Constants.DEFAULT_DECIMAL_PRECISION;

  constructor() {
  }

  setUserInfo(userInfo: UserInfo) {
    this.userInfoSource.next(userInfo);
  }

  setEmailSymbolsChecked(value: boolean) {
    this.emailSymbolCheckedSource.next(value);
  }

  getEmailSymbolsChecked(): boolean {
    const value = this.emailSymbolCheckedSource.getValue();
    return value;
  }

  setAllMasterData(data: AllMasterData) {
    this.allMasterDataValues.next(data);
  }

  updatePreferencesInMasterData(preferences: EstimateUserPreferences){
    const currentData = this.allMasterDataValues.getValue();
    if (currentData) {
      currentData.userPreferences = preferences;
      this.setAllMasterData(currentData);
    }
  }

  setDecimalPrecision(precision: number): void {
    this._decimalPrecision = precision;
  }

  getDecimalPrecision(): number {
    return this._decimalPrecision;
  }
}
